export const AriseFeeTemplateQueue = {
	IsActive: {
		name: "isActive",
		beName: "is_active",
	},
	IsDefault: {
		name: "isDefault",
		beName: "is_default",
	},
	TemplateId: {
		name: "templateId",
		beName: "id",
	},
	Name: {
		name: "name",
		beName: "name",
	},
};
